// import React from "react";
// import "./contact.css";
// import contactImage from "../../img/des_sec/contact_mid.svg"; // Replace with your actual image path

// function ContactSection({openContactModal}) {
//   return (
//     <div className="contact-container-co">
//       <h2 className="contact-heading-co">Contact us</h2>
//       <p className="contact-subtext-co">Have any queries or feedback for us?</p>
      
//       {/* Middle Image */}
//       <div className="contact-image-wrapper-co">
//         <img 
//           src={contactImage} 
//           alt="Contact illustration" 
//           className="contact-image-co" 
//         />
//       </div>
      
//       <button onClick={openContactModal} className="contact-button-co">Connect</button>
//     </div>
//   );
// }

// export default ContactSection;

import React, { useRef, useEffect, useState } from "react";
import { useSpring, animated } from 'react-spring';
import "./contact.css";
import contactImage from "../../img/des_sec/contact_mid.svg"; // Replace with your actual image path

function ContactSection({openContactModal}) {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Animation for heading - only opacity and subtle transform
  const headingAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 200, 
      friction: 40,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for subtext - only opacity and subtle transform
  const subtextAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(8px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 250 : 0
  });

  // Animation for image - minimal movement to avoid layout issues
  const imageAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(10px)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1
    },
    delay: inView ? 400 : 0
  });

  // Animation for button - minimal movement
  const buttonAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(8px)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 600 : 0
  });

  return (
    <div className="contact-container-co" ref={containerRef}>
      <animated.h2 
        className="contact-heading-co"
        style={{
          ...headingAnimation,
          position: 'relative',
          zIndex: 1
        }}
      >
        Contact us
      </animated.h2>
      
      <animated.p 
        className="contact-subtext-co"
        style={{
          ...subtextAnimation,
          position: 'relative',
          zIndex: 1
        }}
      >
        Have any queries or feedback for us?
      </animated.p>
      
      {/* Middle Image */}
      <animated.div 
        className="contact-image-wrapper-co"
        style={{
          ...imageAnimation,
          position: 'relative',
          zIndex: 1
        }}
      >
        <img 
          src={contactImage} 
          alt="Contact illustration" 
          className="contact-image-co" 
        />
      </animated.div>
      
      <animated.button 
        onClick={openContactModal} 
        className="contact-button-co"
        style={{
          ...buttonAnimation,
          position: 'relative',
          zIndex: 1
        }}
      >
        Connect
      </animated.button>
    </div>
  );
}

export default ContactSection;